import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

const AuthWellevatePractitionerSignUp_UnauthenticatedWellevateAuthorize_Mutation = gql`
  mutation AuthWellevatePractitionerSignUp_UnauthenticatedWellevateAuthorize_Mutation(
    $input: AuthWellevatePractitionerSignUpInput!
  ) {
    auth {
      wellevatePractitionerSignUp(input: $input) {
        redirectPath
        errors {
          message
        }
      }
    }
  }
`;

interface AuthWellevatePractitionerSignUpData {
  auth: {
    wellevatePractitionerSignUp: {
      redirectPath: string;
      errors: {
        message: string;
      };
    };
  };
}

interface Variables {
  input: {
    attributes: {
      email: string;
      password: string;
      firstName: string;
      lastName: string;
      storeName: string;
      practitionerTypeId: string;
      wellevatePractitionerId: string;
      pageVersion: string;
      signUpPage: string;
      optional: {
        source: string;
        redirectPath: string;
      };
    };
    captchaToken: string;
  };
}

const useAuthWellevatePractitionerSignUpMutation = (
  options: MutationHookOptions<AuthWellevatePractitionerSignUpData, Variables>
) =>
  useMutation(AuthWellevatePractitionerSignUp_UnauthenticatedWellevateAuthorize_Mutation, options);

export type { AuthWellevatePractitionerSignUpData };
export {
  useAuthWellevatePractitionerSignUpMutation,
  AuthWellevatePractitionerSignUp_UnauthenticatedWellevateAuthorize_Mutation,
};
